import React, { createContext, useContext, useState } from 'react';
import { useAuthToken } from './AuthTokenContext';
const BankingContext = createContext();

export function BankingProvider({ children }) {
  const { authAxios } = useAuthToken();

  const bankUrl = process.env.REACT_APP_BANK_API_URL;

  const createPaymentIntent = async () => {
    const response = await authAxios.post(`${bankUrl}/create-payment-intent`);
    return response.data;
  };

  const checkPaymentIntent = async () => {
    const response = await authAxios.post(`${bankUrl}/check-payment-intent`);
    return response.data;
  };

  return (
    <BankingContext.Provider value={{
      createPaymentIntent,
      checkPaymentIntent
    }}>
      {children}
    </BankingContext.Provider>
  );
}

export function useBanking() {
  return useContext(BankingContext);
}
